import { __module as e } from "../../../_virtual/unescape.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(a = e.exports, "__esModule", {
  value: !0
}), a.default = function (e) {
  return (0, t.default)(e), e.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
}, t = r && r.__esModule ? r : {
  default: r
}, e.exports = a.default, e.exports.default = a.default;
var a,
  t,
  l = e.exports;
export { l as _ };